import { render, staticRenderFns } from "./LocationIcon.vue?vue&type=template&id=56b34fd9&"
import script from "./LocationIcon.vue?vue&type=script&lang=ts&"
export * from "./LocationIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports